module.exports = __webpack_public_path__ + "static/media/zocaloSanitarioJ.b40fe6d7.jpg";